import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e03d616"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "address-box"
};
const _hoisted_2 = {
  class: "address-time"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "收件人", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "手机号", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "所在地区", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "详细地址", -1));
const _hoisted_7 = {
  class: "address-dec"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_config_provider = _resolveComponent("van-config-provider");
  const _component_CompPicker = _resolveComponent("CompPicker");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_config_provider, {
    "theme-vars": $data.themeVars
  }, {
    default: _withCtx(() => [_createVNode(_component_van_popup, {
      class: "address-popup",
      show: $options.showEdit,
      "onUpdate:show": _cache[6] || (_cache[6] = $event => $options.showEdit = $event),
      onOpen: $options.open
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.fill_end_time ? $props.fill_end_time + '前可修改地址' : '不支持修改地址'), 1), _createElementVNode("i", {
        class: "address-close",
        onClick: _cache[0] || (_cache[0] = (...args) => $options.closePickerEdit && $options.closePickerEdit(...args))
      }), _createElementVNode("div", {
        class: _normalizeClass(['address-item', {
          'address-item-disabled': $options.cannotEdit
        }])
      }, [_hoisted_3, _createVNode(_component_van_field, {
        modelValue: $data.address_name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.address_name = $event),
        placeholder: "请输入收件人",
        disabled: $options.cannotEdit
      }, null, 8, ["modelValue", "disabled"])], 2), _createElementVNode("div", {
        class: _normalizeClass(['address-item', {
          'address-item-disabled': $options.cannotEdit
        }])
      }, [_hoisted_4, _createVNode(_component_van_field, {
        modelValue: $data.address_mobile,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.address_mobile = $event),
        placeholder: "请输入中国大陆手机号码",
        disabled: $options.cannotEdit
      }, null, 8, ["modelValue", "disabled"])], 2), _createElementVNode("div", {
        class: _normalizeClass(['address-item', {
          'address-item-disabled': $options.cannotEdit
        }])
      }, [_hoisted_5, _createVNode(_component_van_field, {
        modelValue: $data.pickerInfo.address_obj,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.pickerInfo.address_obj = $event),
        "is-link": "",
        readonly: "",
        placeholder: "省/市/区",
        onClick: $options.openPicker
      }, null, 8, ["modelValue", "onClick"])], 2), _createElementVNode("div", {
        class: _normalizeClass(['address-item', 'address-item-last', {
          'address-item-disabled': $options.cannotEdit
        }])
      }, [_hoisted_6, _createVNode(_component_van_field, {
        modelValue: $data.address,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.address = $event),
        placeholder: "请输入详细地址",
        disabled: $options.cannotEdit
      }, null, 8, ["modelValue", "disabled"])], 2), _createElementVNode("div", _hoisted_7, _toDisplayString($props.describe), 1), _createElementVNode("div", {
        class: _normalizeClass(['address-add-btn', {
          'address-add-btn-disabled': $options.cannotEdit
        }]),
        onClick: _cache[5] || (_cache[5] = (...args) => $options.addAddress && $options.addAddress(...args))
      }, "保存", 2)])]),
      _: 1
    }, 8, ["show", "onOpen"])]),
    _: 1
  }, 8, ["theme-vars"]), _createVNode(_component_CompPicker, {
    show_picker: $data.showPicker,
    "onUpdate:show_picker": _cache[7] || (_cache[7] = $event => $data.showPicker = $event),
    picker_info: $data.pickerInfo,
    onPickerInfo: $options.getPickerInfo
  }, null, 8, ["show_picker", "picker_info", "onPickerInfo"])]);
}